import styled from "styled-components";

export const ContainerMedia = styled.div`
  display: flex;
  justify-content: center;
`;
